import { useCallback, useState } from 'react'
import { useFormikContext } from 'formik'
import AutoComplete from '../../../../components/AutoComplete/AutoComplete'
import { useCheckin } from './CheckinContext'
import LinhaEditavelCard from './LinhaEditavelCard'

const AdicionaisCard = ({ preencherAltura }) => {
  const [textFieldAc, setTextFieldAc] = useState('')
  const { values, isSubmitting } = useFormikContext()

  const { isFinalizado } = useCheckin()
  const {
    listaProdutosAdicionais,
    listaVendas,
    updateProdutoAdicional,
    addProdutoAdicional,
    removeProdutoAdicional,
    updateVenda,
    removeVenda,
  } = useCheckin()
  const isDisabled = isSubmitting || isFinalizado

  const mergedList = [...listaProdutosAdicionais, ...listaVendas]

  const handleUpdate = useCallback(
    (idx, updates) => {
      const isAdicional = listaProdutosAdicionais.some(
        (item) => item.idx === idx,
      )
      if (isAdicional) {
        updateProdutoAdicional(idx, updates)
      } else {
        updateVenda(idx, updates)
      }
    },
    [listaProdutosAdicionais, updateProdutoAdicional, updateVenda],
  )

  const handleDelete = useCallback(
    (idx) => {
      const isAdicional = listaProdutosAdicionais.some(
        (item) => item.idx === idx,
      )
      if (isAdicional) {
        removeProdutoAdicional(idx)
      } else {
        removeVenda(idx)
      }
    },
    [listaProdutosAdicionais, removeProdutoAdicional, removeVenda],
  )

  return (
    <LinhaEditavelCard
      titulo="Venda no Check-in"
      lista={mergedList}
      onUpdateItem={handleUpdate}
      comSolicitado
      comExclusao={!isFinalizado}
      onDelete={handleDelete}
      preencherAltura={preencherAltura}
      conteudoTopo={
        !isFinalizado ? (
          <AutoComplete
            fullWidth
            getOptionLabel={(v) => v?.[1]}
            InputLabelProps={{ shrink: true }}
            label="Adicionar Produto"
            metodo="buscaProdutoTerapiaPontoVenda"
            disabled={isDisabled}
            value={values?.acProduto}
            textFieldProps={{
              onChange: (v) => setTextFieldAc(v.target.value),
            }}
            onChange={(_, produto) => {
              setTextFieldAc('')
              if (produto?.[0]?.[0]) addProdutoAdicional(produto)
            }}
            inputValueAc={textFieldAc}
          />
        ) : null
      }
    />
  )
}

export default AdicionaisCard
